<template src="./MainLayout.html"></template>

<script lang="ts">
import { defineComponent } from "vue";
import AppFooter from "@/components/AppFooter";
import AppHeader from "@/components/AppHeader";
import SideMenu from "@/components/SideMenu";

export default defineComponent({
    components: {
        AppHeader,
        SideMenu,
        AppFooter
    }
});
</script>

<style src="./MainLayout.scss" lang="scss" scoped></style>
